import o from "react";
const a = _ref => {
  let {
    open: e
  } = _ref;
  return o.createElement("div", {
    className: "olx-header__overlay",
    "data-open": e,
    "data-testid": "mobile-overlay-overflow-menu"
  });
};
export { a as Overlay };